<template>
  <b-card>
    <BookForm
      :params="params"
      :result="result"
      :pack="pack"
      :category="category"
      :meal="meal"
      @back="onBack"
      @book="onBook"
      />
  </b-card>
</template>

<script>
import model from './services/model'
import { routeGuard } from './router'
import { getHotelInfo } from 'b2b-common/services/api/hotel'
import BookForm from './components/book_form'

export default {
  beforeRouteUpdate (to, from, next) {
    routeGuard(to, from, next)
  },
  components: { BookForm },
  async created () {
    const routeParams = this.$route.params
    const result = model.results.find(el => el.id.toString() === routeParams.Result.toString())
    if (result.hotelInfo) return

    const res = await getHotelInfo({ hotelId: result.id })
    if (Array.isArray(res) && res.length) {
      const hotelInfo = res[0]
      this.$set(result, 'hotelInfo', hotelInfo)
    }
  },
  data () {
    const routeParams = this.$route.params
    const result = model.results.find(el => el.id.toString() === routeParams.Result.toString())

    const pack = result.packages.find(el => el.id.toString() === routeParams.Package.toString())
    const category = pack.categories.find(el => el.id.toString() === routeParams.Category.toString())
    const meal = category.meals[routeParams.Meal]

    return {
      params: model.params,
      result: result,
      pack: pack,
      category: category,
      meal: meal
    }
  },
  methods: {
    onBack () {
      this.$router.push({ name: 'Private/Package/Search' })
    },
    onBook (id) {
      this.$router.push({ name: 'Private/Bookings/View', params: { Id: id } })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
